{
  "linkTo": "Set Location",
  "locationNotPinned": "Location Unpinned",
  "locationPinned": "Location Pinned",
  "locationPinnedExplanation": "\"Location Pinned\" means that the device's location has been set manually and will be used in place of the GPS location.",
  "locationUnpinnedExplanation": "\"Location Unpinned\" means that the device's location is being determined by the GPS chip.",
  "pinnedLocation": "Pinned Location",
  "pinningExplanation": "Pinning the device's location will override the current reading from the gps chip. You may want to do this if your device has consistently poor gps reception, for example a pump installed inside of a warehouse with a metal rooftop.",
  "tapTheMapToSetLocation": "Tap the map to set permanent location",
  "title": "Pin Device Location",
  "unpinButton": "Clear"
}
